import { useState } from 'react';
import axios from 'axios';
import { genderMapping } from '../Constants/gender';
import { formatDateStringIfMatches } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_DRG_GROUPER_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_DRG_GROUPER_API_BASE_URL;

export default function useDrgGrouperApi() {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    const executeRequest = (request) => {
        setLoading(true);
        setSuccess(false);
        setError(null);
        setResult(null);

        axios.post(`${BASE_URL}/drg`, {
            birthDate: formatDateStringIfMatches(request.birthDate || null, DATE_STRING_FORMAT, API_DATE_STRING_FORMAT),
            admitDate: formatDateStringIfMatches(request.admitDate || null, DATE_STRING_FORMAT, API_DATE_STRING_FORMAT),
            dischargeDate: formatDateStringIfMatches(request.dischargeDate || null, DATE_STRING_FORMAT, API_DATE_STRING_FORMAT),
            sex: genderMapping[request.gender] || null,
            dischargeStatus: Number(request.dischargeStatus) || null,
            primaryPayer: 'Medicare',
            applyHACLogic: 'Required',
            principalDiagnosisCode: (request.diagnosisCodes[0] && request.diagnosisCodes[0].diagnosisCode && {
                code: request.diagnosisCodes[0].diagnosisCode,
                poa: request.diagnosisCodes[0].poa || null
            }) || null,
            principalProcedureCode: (request.procedureCodes[0] && request.procedureCodes[0].procedureCode) || null,
            secondaryDiagnosisCodes: [
                ...request.diagnosisCodes.filter((dc, index) => index !== 0 && dc.diagnosisCode).map(dc => {
                    return {
                        code: dc.diagnosisCode,
                        poa: dc.poa || null
                    };
                })
            ],
            secondaryProcedureCodes: [
                ...request.procedureCodes.filter((p, index) => index !== 0 && p.procedureCode).map(p => p.procedureCode)
            ]
        })
            .then(({ data }) => {
                setResult(data);
                setSuccess(true);
            }).catch(e => {
                setError(e);
            }).finally(() => {
                setLoading(false);
            });
    };

    const executeReset = () => {
        setLoading(false);
        setSuccess(false);
        setError(null);
        setResult(null);
    }

    return {
        loading, 
        success, 
        error, 
        result, 
        execute: executeRequest, 
        reset: executeReset
    };
}